import type { ResultDetail } from '../../../../../../graphql/rest-link/types';
import { gql } from '@apollo/client';

export const GET_RESULT_DETAIL = gql`
  query getResultDetail($locale: String, $eventUniqueCode: ID!, $resultUniqueCode: ID!) {
    getResultDetail(
      locale: $locale
      eventUniqueCode: $eventUniqueCode
      resultUniqueCode: $resultUniqueCode
    )
      @rest(
        type: "ResultDetail"
        path: "/v2/api/events/{args.eventUniqueCode}/detail/{args.resultUniqueCode}"
        method: "GET"
        endpoint: "bff"
        pathBuilder: $pathBuilder
      ) {
      id
      resultId
      subEventId
      finisherCertificate
      finisherCertificateFilename
      finisherCertificateTemplate
      raceMap
      stats {
        featured
        notFeatured
        primary
        ranking
        general
      }
      segmentResults
      awards {
        awardId
        label
        place
        placeOrdinal
      }
      medals {
        id
        title
        url
      }
      participant {
        id
        profileImage
        displayNameInitials
        displayName
        name
        fromLocation
        subEventName
        bib
        team
        genderLabel
        age
        division
        ageGroup
        participantImage
        edit
        nationality
      }
      result
      menu
      hasActivityPostedToday
      remainingPerDay
      isActivitiesEditable
      showRaceStatus
      brandMarketplaceOffers {
        offerId
        brandName
        name
        overviewImage
        productPrice {
          amount
          currency
        }
        platformEntityId
        activationId
        description
        descriptionTitle
        participantOfferCallToAction
        category
      }
    }
  }
`;

export type GetResultDetailVariables = {
  locale: string;
  eventUniqueCode: string;
  resultUniqueCode: string;
};

export type GetResultDetailData = {
  getResultDetail: ResultDetail;
};
